import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import { initNotifier } from '../../utils/notifier'

const NotifierInitializer = () => {
  const { enqueueSnackbar } = useSnackbar()
  
  useEffect(() => {
    initNotifier(enqueueSnackbar)
  }, [enqueueSnackbar])

  return null
}

export default NotifierInitializer